export default __webpack_public_path__ + "static/enfermeria-mobile-2d9bd495954570c8e2f75356767bd834.svg";